import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';


@Component({
  selector: 'app-newPreferences',
  templateUrl: './newPreferences.component.html',
})
export class NewPreferencesComponent implements OnInit {

  constructor(
    private _authorizeService: AuthorizeService) {

  }

  ngOnInit() {

  }

}
